// extracted by mini-css-extract-plugin
export default {"header_container":"Header_header_container__dn6Ya","title":"Header_title__x3ga3","subtitle":"Header_subtitle__4RLMY"};